import UILink from 'UIComponents/link/UILink';
import { useLessonProgressById } from '../../userProgress';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error untyped module
import { useParentAppName } from '../../../hooks/searchParamHooks';
import { appendQueryParams } from '../../../utils/urls';
import { useLesson, useShorts } from '../../../hooks/contentHooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const AcademyRedirectLink = ({
  link,
  lessonId,
  shortId,
  language,
  onClick,
  LinkComponent,
  isPublic = false
}) => {
  const {
    lessonProgressById
  } = useLessonProgressById(lessonId, isPublic || !lessonId);
  const {
    lesson
  } = useLesson(lessonId, language, isPublic);
  const {
    shortFormContent
  } = useShorts(shortId, isPublic);
  const progress = lessonProgressById === null || lessonProgressById === void 0 ? void 0 : lessonProgressById.status;
  const name = (lesson === null || lesson === void 0 ? void 0 : lesson.name) || (shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.name);
  const parentAppName = useParentAppName();
  const href = appendQueryParams(link, {
    utm_source: parentAppName,
    utm_medium: 'embedded'
  });
  if (LinkComponent) {
    return /*#__PURE__*/_jsx(LinkComponent, {
      "data-test-id": "embedded-academy-redirect-link",
      href: link,
      onClick: onClick
    });
  }
  if (!lessonId && shortId) {
    return /*#__PURE__*/_jsx(UILink, {
      "data-test-id": "embedded-academy-redirect-link",
      external: true,
      href: link,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyAiPrompt.goToShortFormVideo"
      })
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      UILink: LinkComponent || UILink
    },
    message: progress === 'NOT_STARTED' || isPublic ? 'academyAiPrompt.videoFromLesson_jsx' : progress === 'COMPLETED' ? 'academyAiPrompt.videoFromCompletedLesson_jsx' : 'academyAiPrompt.videoFromEnrolledLesson_jsx',
    options: {
      name,
      href,
      onClick,
      testId: 'embedded-academy-redirect-link'
    }
  });
};